import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));
export default function ContainedSelect(props) {
  const classes = useStyles();
      const inputLabel = React.useRef(null);
      const [labelWidth, setLabelWidth] = React.useState(0);
      React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
      }, []);
      const handleChange = event => {
        props.handleChangeSelect(event.target.value, props.id)
        };
      const {data} = props;
        return (
            <div>
            <FormControl error={props.error} variant={props.variant} className={classes.formControl}>
              <InputLabel
              className={props.classNamelabel}
               ref={inputLabel} htmlFor="outlined-age-native-simple">
                {props.textLabel}
              </InputLabel>
              <Select    
                  id={props.id}   
                  className={props.className}
                  required={props.required}
                  disabled={props.disabled}
                  value={props.value == null || undefined ?"":String(props.value)}
                  onChange={handleChange}
                  labelWidth={labelWidth}
                  inputProps={{
                    name: props.required == true?"requiredField":"",
                  }}
                  >
                  {data &&
                    data.map(item => (
                    <MenuItem classes={{root: 'ListItem', selected:'ListItemSelect'}} value={item}>{item}</MenuItem>
                  ))
                  }
              </Select>
              </FormControl>
            </div>
        );
    }
